module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-03@2x.c2b9ae28.jpg";